import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { fetchData } from '../utils/runtime.js';

export default function MaintenanceGate({ children }) {
    const [active, setActive] = useState(false);

    useEffect(() => {
        const email = Cookies.get('email');
        const check = async () => {
            try {
                const globalStatus = await fetchData('/api/maintenance');
                if (globalStatus && globalStatus.maintenance) {
                    if (email === 'jazeelakarima@gmail.com') {
                        setActive(false);
                        return;
                    }
                    setActive(true);
                    return;
                }
                if (email) {
                    const user = await fetchData(`/api/maintenance/user?email=${encodeURIComponent(email)}`);
                    if (user && user.maintenance) {
                        setActive(true);
                        return;
                    }
                }
                setActive(false);
            } catch (err) {
                console.error('Failed to load maintenance status', err);
            }
        };
        check();
    }, []);

    if (active) {
        return (
            <div className="flex items-center justify-center h-screen text-white bg-gray-900">
                <p>The site is currently under maintenance.</p>
            </div>
        );
    }

    return children;
}
